<!-- mouseenter/mouseleave (not mouseover/mouseout): the bubbling pair refired for
     every child element the pointer crossed, emitting a marker update per event. -->
<div class="page-head" (mouseenter)="addHighlight(business.lat, business.lng)"
     (mouseleave)="removeHighlight(business.lat, business.lng)">
  <div class="head-inner-left">
    <div class="name-wrap">
      <div class="page-title-wrap">
        <table>
          <tbody>
            <tr>
              <td>
                <h1 ngbTooltip="{{business.name}}" class="page-title">{{business.name}}</h1>
              </td>
              <td>
                <span class="status">{{business.status}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <app-button *ngIf="isAllowEdit" [btnCss]="'btn btn-outline-primary'" class="edit-btn-outer"
                  [btnTitle]="'Edit Details'" [btnText]="'Edit Details'"
                  [routerLink]="['/onboarding', business.branchId]"></app-button>
    </div>
    <div class="ul-wrap ul-wrap-start">
      <ul class="restro-info">
        <li *ngIf="business.typeName">{{business.typeName}}</li>
        <li *ngIf="business.cuisineName">{{business.cuisineName}}</li>
        <li *ngIf="business.priceRange">{{business.priceRange}}</li>
        <li ngbTooltip="Coming soon" tooltipClass="tooltip-custom">Top 20 places</li>
      </ul>
      <div class="btn-grps like-share-btn-grps">
        <!-- No favourites API behind Like yet: announce it rather than act. aria-disabled
             keeps it focusable (so the tooltip is reachable) while saying it does nothing. -->
        <a role="button" tabindex="0" class="pointer" aria-label="Like this business"
           aria-disabled="true" ngbTooltip="Coming soon" tooltipClass="tooltip-custom">
          <img src="./assets/images/ic-like.svg" alt="" />
        </a>
        <a role="button" tabindex="0" class="pointer" title="Share" aria-label="Share this business"
           (click)="sharePage()" (keydown.enter)="sharePage()" (keydown.space)="sharePage(); $event.preventDefault()">
          <img src="./assets/images/ic-share.svg" alt="" />
        </a>
      </div>
    </div>
  </div>
  <div class="head-inner-right">
    <div class="ratings-wrap" tooltipClass="tooltip-custom">
      <h5 class="rating-data">{{business.totalReviews}} reviews</h5>
      <ngx-stars *ngIf="showRatings" [readonly]="true" [size]="1" [color]="business.totalReviews > 0 ? '#AE77A0' : '#CACEDC'" [initialStars]="business.averageRating"></ngx-stars>
    </div>
  </div>
</div>

<div class="nac-cta-outer" (mouseenter)="addHighlight(business.lat, business.lng)"
     (mouseleave)="removeHighlight(business.lat, business.lng)">
  <div class="nav-cta-wrap">
    <div class="datepicker-grp" ngbTooltip="Coming soon" tooltipClass="tooltip-custom">
      <app-datepicker-input placeholder="Enter Date" [control]="formGroup.get('date')"
                            (dropdownShow)="toggleDropdown($event)" [ngClass]="dropdownVisible ? 'dateClass' : ''"></app-datepicker-input>
    </div>
    <app-select [options]="times" [selectClass]="'ng-form-select custom time-select'"
                selectPlaceholder="Enter Time" ngbTooltip="Coming soon" tooltipClass="tooltip-custom"></app-select>
    <app-select [options]="peoples" [selectClass]="'ng-form-select custom people-select'"
                selectPlaceholder="People" ngbTooltip="Coming soon" tooltipClass="tooltip-custom"></app-select>
    <app-button [btnCss]="'btn btn-primary'" class="find-btn-outer" [btnText]="'Find Table'" ngbTooltip="Coming soon" tooltipClass="tooltip-custom"></app-button>
  </div>

  <div class="user-cmt d-none d-lg-flex" *ngIf="business.totalReviews > 0" ngbTooltip="{{quickPhrase}}" tooltipClass="tooltip-custom">
    <h5 class="cmt">
      <span>{{quickPhrase}}</span>
    </h5>
    <span class="img-block">
      <img src="./assets/images/user-profile.png" alt="Profile" />
    </span>
  </div>
  <div class="user-cmt d-none d-lg-flex" *ngIf="business.totalReviews == 0" ngbTooltip="Be the first one to review!" tooltipClass="tooltip-custom">
    <h5 class="cmt">
      <span>Be the first one to review!</span>
    </h5>
    <span class="img-block">
      <img src="./assets/images/user-profile.png" alt="Profile" />
    </span>
  </div>
</div>
